// extracted by mini-css-extract-plugin
module.exports = {"trigger":"autoOrderPopover_trigger__b4_06"};